import { env } from 'app/Env/env';
import axios, { AxiosResponse } from 'axios';

export const CSRF_HEADER = 'x-csrf-token';

// The widget web components share the page and the global axios default, so the
// portal's own calls go through an instance of their own.
const adminPortalInstance = axios.create({ withCredentials: true });

// Note: added headers should also be specified in the nock mock
const adminPortalHeaders = (
	projectId: string,
	refreshToken?: string,
	cookieName?: string
) => ({
	'x-Current-Project': projectId,
	...(refreshToken ? { Authorization: `Bearer ${refreshToken}` } : {}),
	...(cookieName ? { 'x-descope-refresh-cookie-name': cookieName } : {})
});

export const adminPortalGet = async <T>(
	url: string,
	projectId: string,
	refreshToken?: string,
	cookieName?: string
): Promise<AxiosResponse<T>> =>
	adminPortalInstance.get<T>(url, {
		baseURL: env.baseUrl || undefined,
		headers: adminPortalHeaders(projectId, refreshToken, cookieName)
	});

export const adminPortalPost = async <TBody, TRes = TBody>(
	url: string,
	body: TBody,
	projectId: string,
	refreshToken?: string,
	cookieName?: string,
	csrfToken?: string
): Promise<AxiosResponse<TRes>> =>
	adminPortalInstance.post<TBody, AxiosResponse<TRes>>(url, body, {
		baseURL: env.baseUrl || undefined,
		headers: {
			...adminPortalHeaders(projectId, refreshToken, cookieName),
			...(csrfToken ? { [CSRF_HEADER]: csrfToken } : {})
		}
	});

export const getStatic = async <T>(url: string): Promise<AxiosResponse<T>> => {
	const res = await axios.get<T>(url, {
		baseURL: env.baseStaticUrl || undefined
	});

	return res;
};
